import { ArrowBack } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import { useState } from "react";
import {
  Button,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
const ProfileShow = () => {
  const record = useRecordContext();

  if (!record) return <div>Loading...</div>;

  return (
    <SimpleShowLayout>
      <TextField source="sBankName" label="Institution Name" />
      <TextField
        source="esign_firstname"
        label="E-Signature Sender First Name"
      />
    </SimpleShowLayout>
  );
};

const EditToolbar = (props: any) => {
  const { reset } = useFormContext();
  // const notify = useNotify();
  const { success, error, info } = useNotify();
  const { getValues, formState } = useFormContext();
  const isDirty = formState.isDirty;

  const record = useRecordContext();
  const id = record?.id;
  const handleUndo = () => {
    reset();
    //set isDirty to false
    success("Changes have been cancel");
  };

  const saveData = () => {
    const reqUrl = "banks/actions/edit";

    const formData = isDirty ? getValues() : null;
    if (formData) {
      var saveFormData = {
        institution_name: formData.sBankName,
        organization_type: formData.sOrganizationType,
        business_type: formData.sBussinessType,
        business_name: formData.sBussinessClassification,
        ein: formData.sEin,
        street: formData.sStreet,
        street2: formData.sStreet2,
        city: formData.sCity,
        state: formData.sState,
        zip: formData.sZip,
        bankUrl: formData.sUrl,
        saveType: "info",
      };
      if (!saveFormData?.institution_name) {
        error("Institution Name is required");
        return false;
      }
      if (!saveFormData?.organization_type) {
        error("Organization Type is required");
        return false;
      }
      if (!saveFormData?.business_type) {
        error("Business Type is required");
        return false;
      }
      if (!saveFormData?.business_name) {
        error("Business Name is required");
        return false;
      }
      if (!saveFormData?.ein) {
        error("EIN is required");
        return false;
      }
      if (!saveFormData?.street) {
        error("Street is required");
        return false;
      }
      if (!saveFormData?.city) {
        error("City is required");
        return false;
      }
      if (!saveFormData?.state) {
        error("State is required");
        return false;
      }
      if (!saveFormData?.zip) {
        error("Zip Code is required");
        return false;
      }
      if (!saveFormData?.bankUrl) {
        error("Institution Website is required");
        return false;
      }

      sendRequest(reqUrl, { id: id, data: saveFormData }).then((res) => {
        if (res?.code == 200) {
          success("Saved successfully");
          reset(formData);
        } else {
          error("Error saving " + res?.message);
        }
      });
    } else {
      error("Error saving description: No data to save");
    }
  };
  return (
    <Box
      sx={{
        display: "block",
        mt: "2px",
        borderRadius: "0px",
        paddingTop: "0px",
      }}
    >
      <Toolbar
        {...props}
        sx={{
          background: "white",
          justifyContent: "space-between",
          // border: "1px solid red",
          borderTop: "1px solid #e0e0e0",
          padding: "0px",
          "&.MuiToolbar-root.RaToolbar-root": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
        }}
      >
        <CustomButtonCancel label="Undo" onClick={handleUndo} />
        {/* <SaveButton /> */}
        <CustomButtonSave
          variant="contained"
          color="primary"
          onClick={saveData}
          disabled={!isDirty}
          sx={{
            width: "120px",
          }}
        />
      </Toolbar>
    </Box>
  );
};

const ProfileEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();

  if (!record) return <div>Loading...</div>;
  return (
    <SimpleForm toolbar={<EditToolbar />}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        {admin ? (
          <HmTextInput
            source="sBankName"
            label="Institution Name"
            validate={[required()]}
            readonly={true}
          />
        ) : (
          <TextInput
            source="sBankName"
            label="Institution Name"
            sx={{
              width: "100%",
              "& input.Mui-disabled": {
                // backgroundColor: "#ddd",
                // borderRadius: "10px",
                color: "#00000061",
              },
            }}
            helperText={false}
            variant="outlined"
            // disabled
            readOnly
          />
        )}

        <SelectInput
          source="sOrganizationType"
          label="Type of Organization"
          defaultValue={record?.sOrganizationType}
          choices={[
            { id: "Bank", name: "Bank" },
            { id: "Credit Union", name: "Credit Union" },
            { id: "CDFI", name: "CDFI" },
            { id: "Other", name: "Other" },
          ]}
          fullWidth
          variant="outlined"
          helperText={false}
          readOnly={isEdit ? false : true}
        />

        <SelectInput
          source="sBussinessType"
          label="Business Type"
          defaultValue={record?.sBussinessType}
          choices={[
            {
              id: "soleProprietorship",
              name: "Sole proprietorships/Unincorporated association/Trust",
            },
            {
              id: "corporation",
              name: "Corporation/Publicly traded corporations/Non-Profits",
            },
            { id: "llc", name: "LLCs" },
            {
              id: "partnership",
              name: "Partnerships,LP's,LLP's",
            },
          ]}
          fullWidth
          variant="outlined"
          helperText={false}
          readOnly={isEdit ? false : true}
        />
        <SelectInput
          source="sBussinessClassification"
          label="Industry"
          defaultValue={record?.sBussinessClassification}
          choices={[
            {
              id: "Credit union",
              name: "Credit union",
            },
            {
              id: "Mortgage brokers and dealers",
              name: "Mortgage brokers and dealers",
            },
            {
              id: "Consumer lending",
              name: "Consumer lending",
            },
            {
              id: "Commercial Banking",
              name: "Commercial Banking",
            },
          ]}
          fullWidth
          variant="outlined"
          helperText={false}
          readOnly={isEdit ? false : true}
        />
        <HmTextInput
          source="sEin"
          label="Institution EIN"
          validate={[required()]}
          className="numericText"
          readOnly={isEdit ? false : true}
        />

        {/* sStreet, sStreet2, sCity, sState, sZip */}
        {/* <CustomAddress record={record} /> */}
        <Grid
          container
          spacing={2}
          sx={{
            mt: "0px",
            pt: "0px",
            "& .MuiGrid-item": { mt: "0px", pt: "0px" },
          }}
        >
          <Grid item xs={12} sm={6} sx={{ mt: "0px", pt: "0px" }}>
            <HmTextInput
              source="sStreet"
              // name="street"
              label="Street"
              validate={[required()]}
              readOnly={isEdit ? false : true}
            />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ mt: "0px", pt: "0px" }}>
            <HmTextInput
              source="sStreet2"
              label="Street 2"
              readOnly={isEdit ? false : true}
            />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ mt: "0px", pt: "0px" }}>
            <HmTextInput
              source="sCity"
              label="City"
              validate={[required()]}
              readOnly={isEdit ? false : true}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <HmTextInput
              source="sState"
              label="State"
              validate={[required()]}
              readOnly={isEdit ? false : true}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <HmTextInput
              source="sZip"
              label="Zip Code"
              validate={[required()]}
              className="numericText"
              readOnly={isEdit ? false : true}
            />
          </Grid>
        </Grid>
        {/* Institution Website */}
        <HmTextInput
          source="sUrl"
          label="Institution Website"
          validate={[required()]}
          format={(value) => {
            if (value && !value.startsWith("http")) {
              return `http://${value}`;
            }
            return value;
          }}
          parse={(value) => {
            if (value && !value.startsWith("http")) {
              return `http://${value}`;
            }
            return value;
          }}
          readOnly={isEdit ? false : true}
        />
      </Box>
    </SimpleForm>
  );
};

const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("Profile updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Profile"
      actions={<Actions />}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<ProfileEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default Profile;
